module.exports = __webpack_public_path__ + "img/KinokoTable22.c277e665.jpg";